export default __webpack_public_path__ + "assets/images/icon-delete.590e5e0aab565d72a27df4e6674bfd62.svg";